import $ from "jquery";
import AjaxRequest from "../modules/ajax-request";
import Recaptcha from "../modules/recaptcha";

class RegisterNew {
    constructor(divSubscriptions, divForm, divRender) {
        this._divForm = divForm;
        this._divRender = divRender;
        this._renderActionUrl = this._divRender.data("render-action");
        this._form = '';
        this._unmaskInput = '';
        this._professionInput = '';
        this._specialtyInput = '';
        this._specialtyOthersInput = '';
        this._formFields = '';

        this.clearData();
        this.init();
    }
    clearData() {
        $(this._divForm).removeAttr("data-form-html");
        $(this._divForm).removeAttr("data-form-action");
    }
    getData() {
        this._form = $('[name="register_new_form"]')
        this._unmaskInput = $('[data-unmask-input]');
        this._professionInput = $('[name="register_new_form[profession]"]');
        this._specialtyInput = $('[name="register_new_form[specialty]"]');
        this._specialtyOthersInput = $('[name="register_new_form[specialtyOthers]"]');
        this._formFields = $(this._form).find('[data-id="register-new-form-field"]');
    }
    init() {
        this.renderContent();
    }
    postRenderContent() {
        this._specialtyInput.parent().hide();
        this._specialtyOthersInput.parent().hide();
    }
    bindEvents() {
        var _thisRegister = this;
        $(this._professionInput).on('change', function () {
            _thisRegister.showFields(this, event);
        });
        $(this._form).on("change", 'select', function (event) {
            _thisRegister.checkValue(event, $(this));
        });
        let _recaptchaLoaded = false;
        $(this._formFields).each(function () {
            $(this).on("click", function () {
                if (!_recaptchaLoaded) {
                    _recaptchaLoaded = true;
                    (new Recaptcha()).domInjection();
                }
            });
        });
        $('body')
            .on("submit", '[name="register_new_form"]', function (event) {
                _thisRegister.formSubmit(event, $(this));
            })
            .on("click", '[data-id="mask"]', function (event) {
                _thisRegister.togglePasswordMask(event, this);
            })
            .on("click", '[data-id="unmask"]', function (event) {
                _thisRegister.togglePasswordMask(event, this);
            })
            .on('change', '[name="register_new_form[birthDate]"]', function () {
                let tmpString = $(this).val().split("-");
                $(this).attr('placeholder', tmpString[2] + '/' + tmpString[1] + '/' + tmpString[0]);
            });
    }
    renderContent() {
        var _thisRegister = this;
        var _ulLinks = this._divRender;
        if (_ulLinks.length > 0) {
            var _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    if (response.renderContentHtml == true) {
                        window.location.replace("https://www.elfarmaceutico.es/perfil.html");
                    } else {
                        _ulLinks.html(response.renderContentHtml);
                        _thisRegister.getData();
                        _thisRegister.postRenderContent();
                        _thisRegister.bindEvents();
                    }
                }
            });

            _ajaxRequest.makeCall(this._renderActionUrl);
        }
    }
    togglePasswordMask(event, element) {
        event.preventDefault();
        $(element).toggleClass("is-active");
        var _unmaskInput = this._unmaskInput;
        if (_unmaskInput.attr("type") === "password") {
            _unmaskInput.attr("type", "text");
            $('[data-id="mask"]').hide();
            $('[data-id="unmask"]').show();
        } else {
            _unmaskInput.attr("type", "password");
            $('[data-id="mask"]').show();
            $('[data-id="unmask"]').hide();
        }
    }
    formSubmit(event, form) {
        event.preventDefault();

        var _divMessage = $('[data-form-message]');
        $(_divMessage).html("");
        $(_divMessage).removeClass("is-success");
        $(_divMessage).removeClass("is-failure");

        var _divMessageAreasOfInterest = $('[data-form-message-areasOfInterest ]');
        $(_divMessageAreasOfInterest).html("");
        $(_divMessageAreasOfInterest).removeClass("is-success");
        $(_divMessageAreasOfInterest).removeClass("is-failure");

        var _divMessagePostalCode = $('[data-form-message-postalCode ]');
        $(_divMessagePostalCode).html("");
        $(_divMessagePostalCode).removeClass("is-success");
        $(_divMessagePostalCode).removeClass("is-failure");

        var _divMessageProvince = $('[data-form-message-province ]');
        $(_divMessageProvince).html("");
        $(_divMessageProvince).removeClass("is-success");
        $(_divMessageProvince).removeClass("is-failure");

        var _divMessageCity = $('[data-form-message-city ]');
        $(_divMessageCity).html("");
        $(_divMessageCity).removeClass("is-success");
        $(_divMessageCity).removeClass("is-failure");

        var ajaxRequest = "";

        ajaxRequest = new AjaxRequest({
            successCallback: function (data) {
                form.removeClass("is-loading");
                $(_divMessage).html(data.message);
                $(_divMessage).addClass("is-success");
                $('[name="register_new_form"]').hide();
            },
            errorCallback: function (data) {
                form.removeClass("is-loading");
                if (data.responseJSON.isAreasOfInterest) {
                    $(_divMessageAreasOfInterest).html(data.responseJSON.message);
                    $(_divMessageAreasOfInterest).addClass("is-failure");
                } else if (data.responseJSON.isPostalCode) {
                    $(_divMessagePostalCode).html(data.responseJSON.message);
                    $(_divMessagePostalCode).addClass("is-failure");
                } else if (data.responseJSON.isProvince) {
                    $(_divMessageProvince).html(data.responseJSON.message);
                    $(_divMessageProvince).addClass("is-failure");
                } else if (data.responseJSON.isCity) {
                    $(_divMessageCity).html(data.responseJSON.message);
                    $(_divMessageCity).addClass("is-failure");
                } else {
                    $(_divMessage).html(data.responseJSON.message);
                    $(_divMessage).addClass("is-failure");
                }
            }
        });

        form.addClass("is-loading");
        $(_divMessage).html("");
        $(_divMessage).removeClass("is-success");
        $(_divMessage).removeClass("is-failure");

        ajaxRequest.makeCall(form.attr('action'), form.serializeArray());
    }

    showFields(professionSelect, event) {
        event.preventDefault();

        if (professionSelect.selectedIndex === 1) {
            this._specialtyInput.parent().show();
            this._specialtyOthersInput.parent().hide();
            document.getElementById("register_new_form_specialtyOthers").options.selectedIndex = 0;
        } else if (professionSelect.selectedIndex === 7) {
            this._specialtyOthersInput.parent().show();
            this._specialtyInput.parent().hide();
            document.getElementById("register_new_form_specialty").options.selectedIndex = 0;
        } else {
            document.getElementById("register_new_form_specialty").options.selectedIndex = 0;
            document.getElementById("register_new_form_specialtyOthers").options.selectedIndex = 0;
            document.getElementById("register_new_form_specialty").options.selectedIndex = 0;
            this._specialtyInput.parent().hide();
            this._specialtyOthersInput.parent().hide();
        }
    }

    checkValue(event, element) {
        if (element.attr('id') === "register_new_form_country") {
            if (element.val() !== "España") {
                $('#register_new_form_postalCode').parent().hide();
                $('#register_new_form_province').parent().hide();
            } else {
                $('#register_new_form_postalCode').parent().show();
                $('#register_new_form_province').parent().show();
            }
        }
    }
}

export default RegisterNew;
